// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useEffect, useMemo } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { useAdjustmentsContextActions } from '../../../../../controllers/adjustments-context';
import { useViewType } from '../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../controllers/issue-adjustments/main';

// Import of Relay genereted types.
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports

import { MAX_NUMBER_OF_UIM_APPS } from './constants';
import { getConfiguredApps } from './utils/get-configured-apps';
/**
 * Matches UIM configs and forge extensions required to render apps.
 * Limtis the amount of apps to render to MAX_NUMBER_OF_UIM_APPS.
 */
export var useAppsToRender = function useAppsToRender(payload) {
  var _data$jira3, _data$jira4, _data$jira6, _data$jira9, _data$jira0;
  var data = payload.data,
    executionContextKey = payload.executionContextKey;
  var _useIssueAdjustmentsA = useIssueAdjustmentsActions(),
    startFieldsInitialisationTimeout = _useIssueAdjustmentsA.startFieldsInitialisationTimeout;
  var _useAdjustmentsContex = useAdjustmentsContextActions(),
    setAdjustmentsAreEnabled = _useAdjustmentsContex.setAdjustmentsAreEnabled,
    setHasFinishedLoading = _useAdjustmentsContex.setHasFinishedLoading;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var viewType = useViewType();
  var configuredApps = useMemo(function () {
    var _data$jira, _data$jira2;
    return getConfiguredApps((_data$jira = data.jira) === null || _data$jira === void 0 || (_data$jira = _data$jira.forge) === null || _data$jira === void 0 ? void 0 : _data$jira.uiModificationsExtensions, (_data$jira2 = data.jira) === null || _data$jira2 === void 0 ? void 0 : _data$jira2.uiModifications);
  }, [(_data$jira3 = data.jira) === null || _data$jira3 === void 0 || (_data$jira3 = _data$jira3.forge) === null || _data$jira3 === void 0 ? void 0 : _data$jira3.uiModificationsExtensions, (_data$jira4 = data.jira) === null || _data$jira4 === void 0 ? void 0 : _data$jira4.uiModifications]);
  var appsToRender = useMemo(function () {
    return configuredApps.slice(0, MAX_NUMBER_OF_UIM_APPS);
  }, [configuredApps]);
  useEffect(function () {
    var _data$jira5;
    if (((_data$jira5 = data.jira) === null || _data$jira5 === void 0 ? void 0 : _data$jira5.uiModifications) !== undefined) {
      setHasFinishedLoading(true);
    }
  }, [setHasFinishedLoading, (_data$jira6 = data.jira) === null || _data$jira6 === void 0 ? void 0 : _data$jira6.uiModifications]);
  useEffect(function () {
    if (appsToRender.length > 0) {
      setAdjustmentsAreEnabled(true);
      startFieldsInitialisationTimeout({
        createAnalyticsEvent: createAnalyticsEvent
      });
    }
  }, [appsToRender, setAdjustmentsAreEnabled, startFieldsInitialisationTimeout, createAnalyticsEvent]);
  useEffect(function () {
    var configuredAppsCount = configuredApps.length;
    if (configuredAppsCount >= 1) {
      var _data$jira7, _data$jira8;
      fireOperationalEvent(createAnalyticsEvent, {
        action: 'success',
        actionSubject: 'jiraUiModifications.configuredAppsPerContext',
        attributes: {
          forgeModulesCount: (_data$jira7 = data.jira) === null || _data$jira7 === void 0 || (_data$jira7 = _data$jira7.forge) === null || _data$jira7 === void 0 ? void 0 : _data$jira7.uiModificationsExtensions.length,
          uimConfiguredAppCount: (_data$jira8 = data.jira) === null || _data$jira8 === void 0 ? void 0 : _data$jira8.uiModifications.length,
          configuredAndInstalledApps: configuredAppsCount,
          areMultipleAppsConfiguredAndInstalled: configuredAppsCount > 1,
          viewType: viewType
        }
      });
    }
  }, [
  // `executionContextKey` is required to track events when execution context changed
  executionContextKey, viewType, createAnalyticsEvent, configuredApps.length, (_data$jira9 = data.jira) === null || _data$jira9 === void 0 || (_data$jira9 = _data$jira9.forge) === null || _data$jira9 === void 0 ? void 0 : _data$jira9.uiModificationsExtensions.length, (_data$jira0 = data.jira) === null || _data$jira0 === void 0 ? void 0 : _data$jira0.uiModifications.length]);
  return appsToRender;
};